




import Vue, { PropType } from "vue";
import Locale from "@/lib/locale";

type Amount = String | Number;

export interface NumberFormatProps {
  amount: Amount;
  locale: string;
  isCurrency: boolean;
  currencyDisplay: string;
}

export interface NumberFormatData {
  list: any;
}

export default Vue.extend({
  name: "vc-number-format",
  props: {
    amount: {
      type: [String, Number] as PropType<NumberFormatProps["amount"]>,
      default: 0
    },
    locale: {
      type: String as PropType<NumberFormatProps["locale"]>,
      default: Locale.getLocale()
    },
    isCurrency: {
      type: Boolean as PropType<NumberFormatProps["isCurrency"]>,
      default: false
    },
    currencyDisplay: {
      type: String as PropType<NumberFormatProps["currencyDisplay"]>,
      default: ""
    }
  },
  data(): NumberFormatData {
    return {
      list: {
        "ja-jp": {
          locales: "ja-JP",
          currency: "JPY"
        },
        "en-us": {
          locales: "en-US",
          currency: "USD"
        },
        "es-es": {
          locales: "fr-FR", // https://typetalk.com/topics/63295/posts/61670411
          currency: "EUR"
        },
        "de-de": {
          locales: "de-DE",
          currency: "EUR"
        },
        "fr-fr": {
          locales: "fr-FR",
          currency: "EUR"
        },
        "ko-kr": {
          locales: "ko-KR",
          currency: "KRW",
          currencyDisplay: "symbol"
        },
        "zh-tw": {
          locales: "zh-TW",
          currency: "NTD",
          currencyDisplay: "code"
        },
        "th-th": {
          locales: "th-TH",
          currency: "USD"
        },
        "id-id": {
          locales: "id-ID",
          currency: "USD"
        },
        "pt-br": {
          locales: "pt-BR",
          currency: "USD"
        },
        "zh-cn": {
          locales: "zh-CN",
          currency: "USD"
        }
      }
    };
  },
  methods: {
    numberFormat(amount: number, isCurrency: boolean) {
      const current = this.$data.list[this.locale];
      let option = {};

      if (isCurrency) {
        option = {
          style: "currency",
          currency: current.currency,
          currencyDisplay: this.currencyDisplay || current.currencyDisplay
        };
      }

      const intlNumberFormat = new Intl.NumberFormat(current.locales, option);
      const formattedNumber = intlNumberFormat.format(amount);

      if (!isCurrency) {
        return formattedNumber;
      }

      if (
        this.currencyDisplay === "code" ||
        current.currencyDisplay === "code"
      ) {
        // デフォルトの形`JPY 25.00`を`25.00 JPY`に変換
        return formattedNumber
          .split(/\s+/)
          .sort()
          .join(" ");
      }

      if (this.locale === "en-us") {
        // デフォルトの型`$10`を`US$10`に変換
        return "US" + formattedNumber;
      } else {
        return formattedNumber;
      }
    }
  }
});
